
import { BASE_URL } from "../endpoints"
import { get } from "../https"

export const getAllCategories = (page:number): Promise<unknown> => {
  console.log(page)
    return get(`${BASE_URL}/categories/staff`)
  }

  export const getCategoryById= (id:string,page:number): Promise<unknown> => {
    console.log(page)

    return get(`${BASE_URL}/categories/staff/${id}/categories`)
  }

  export const getResourcesByCategoryId= (id:string): Promise<unknown> => {
    return get(`${BASE_URL}/categories/staff/${id}/resources`)
  }


  